import Iframe from '../../../../units/Iframe';

const Map = (props) => (
  <Iframe
    logoSrc={props.logo}
    frameBorder="0"
    className="h-100 w-100"
    src={`https://www.google.com/maps/embed/v1/place?key=${props.googleKey}&q=${props.address}`}
    allowFullscreen
  />
);

export default Map;
